// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/EditPoll/index.css
// module id = 2356
// module chunks = 0